import React from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import ErrorImg from '../../assets/img/error.svg';

const ErrorPageNoBack = (props) => {
  const { title, text, subtext } = props;
  return (
    <div className="error-page-no-back">
      <img src={ErrorImg} alt="" className="error-page-no-back-image" />
      <h2 className="error-page-no-back-title epic-text">{title}</h2>
      <p className="error-page-no-back-subtitle">{text}</p>
      <p className="error-page-no-back-subtitle">{subtext}</p>
    </div>
  );
};

ErrorPageNoBack.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  subtext: PropTypes.string,
};

export default withNamespaces()(ErrorPageNoBack);
